import styled, { css } from 'styled-components';

export const Button = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1rem 1.25rem;
  width: 17%;
  height: 3rem;
  color: black;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  background-color: var(--primary);
  border-radius: 0.25rem;
  transition: filter 0.4s;
  margin-left: 1rem;
  &:hover {
    filter: brightness(70%);
    cursor: pointer
  }
`
